//created by sudip
import type { DashboardPreview } from "@/types/dashboardPreview";

export const crmPreview: DashboardPreview = {

    metrics: [

        {
            label: "Open Leads",
            value: "1248",
            trend: "+14%",
        },

        {
            label: "Pipeline",
            value: "$8.6M",
            trend: "+21%",
        },

        {
            label: "Won Deals",
            value: "326",
            trend: "+18%",
        },

        {
            label: "Forecast",
            value: "91%",
            trend: "+7%",
        },

    ],

    chart: {

        title: "Revenue Forecast",

        values: [
            38,
            47,
            55,
            66,
            73,
            84,
            91,
        ],

    },

    activities: [

        {
            title: "Enterprise Deal",
            description: "Subscription signed.",
            status: "success",
        },

        {
            title: "Proposal",
            description: "Submitted for review.",
            status: "info",
        },

        {
            title: "Lead Assigned",
            description: "Healthcare sector.",
            status: "warning",
        },

        {
            title: "Forecast Updated",
            description: "Q4 pipeline.",
            status: "success",
        },

    ],

    insights: [

        "Increase follow-up frequency.",

        "Prioritize enterprise leads.",

        "Automate proposal workflow.",

        "Review inactive opportunities.",

    ],

};

export const erpPreview: DashboardPreview = {

    metrics: [

        {
            label: "Revenue",
            value: "$3.2M",
            trend: "+18%",
        },

        {
            label: "Orders",
            value: "2,846",
            trend: "+11%",
        },

        {
            label: "Inventory",
            value: "18,245",
            trend: "+6%",
        },

        {
            label: "Suppliers",
            value: "284",
            trend: "+9%",
        },

    ],

    chart: {

        title: "Revenue Trend",

        values: [
            40,
            58,
            52,
            70,
            65,
            86,
            78,
        ],

    },

    activities: [

        {
            title: "Purchase",
            description: "PO approved.",
            status: "success",
        },

        {
            title: "Inventory",
            description: "Warehouse synced.",
            status: "info",
        },

        {
            title: "Finance",
            description: "Payments released.",
            status: "success",
        },

        {
            title: "Stock Alert",
            description: "Below minimum.",
            status: "warning",
        },

    ],

    progress: [

        {
            label: "Procurement",
            value: 91,
        },

        {
            label: "Warehouse",
            value: 87,
        },

        {
            label: "Finance",
            value: 95,
        },

        {
            label: "Production",
            value: 83,
        },

    ],

    statuses: [

        {
            title: "Inventory",
            subtitle: "Healthy",
            status: "Normal",
            color: "green",
        },

        {
            title: "Procurement",
            subtitle: "Orders Open",
            status: "Running",
            color: "blue",
        },

        {
            title: "Finance",
            subtitle: "Month Close",
            status: "Review",
            color: "yellow",
        },

        {
            title: "Production",
            subtitle: "Capacity",
            status: "Stable",
            color: "green",
        },

    ],

    insights: [

        "Review slow inventory.",

        "Consolidate suppliers.",

        "Automate approvals.",

        "Increase forecast accuracy.",

    ],

};

export const assetPreview: DashboardPreview = {

    metrics: [

        {
            label: "Assets",
            value: "18,462",
            trend: "+8%",
        },

        {
            label: "Asset Value",
            value: "$48.2M",
            trend: "+12%",
        },

        {
            label: "Work Orders",
            value: "286",
            trend: "Today",
        },

        {
            label: "Compliance",
            value: "98.6%",
            trend: "+2%",
        },

    ],

    chart: {

        title: "Asset Lifecycle",

        values: [
            82,
            76,
            71,
            63,
            48,
            37,
            21,
        ],

    },

    activities: [

        {
            title: "PM Complete",
            description: "HVAC serviced.",
            status: "success",
        },

        {
            title: "Breakdown",
            description: "Generator alert.",
            status: "warning",
        },

        {
            title: "Asset Tagged",
            description: "QR verified.",
            status: "info",
        },

        {
            title: "Calibration",
            description: "Pressure gauge.",
            status: "success",
        },

    ],

    progress: [

        {
            label: "Preventive Maintenance",
            value: 94,
        },

        {
            label: "Asset Verification",
            value: 88,
        },

        {
            label: "Calibration",
            value: 91,
        },

        {
            label: "Warranty Coverage",
            value: 73,
        },

    ],

    statuses: [

        {
            title: "Operational",
            subtitle: "15,824 Assets",
            status: "Healthy",
            color: "green",
        },

        {
            title: "Maintenance",
            subtitle: "286 Assets",
            status: "Active",
            color: "blue",
        },

        {
            title: "Calibration",
            subtitle: "82 Due",
            status: "Pending",
            color: "yellow",
        },

        {
            title: "Retirement",
            subtitle: "37 Assets",
            status: "Review",
            color: "orange",
        },

    ],

    insights: [

        "Schedule overdue PM.",

        "Prioritise critical assets.",

        "Review warranty expiries.",

        "Automate work orders.",

    ],

};

export const healthcarePreview: DashboardPreview = {

    metrics: [

        {
            label: "Patients",
            value: "842",
            trend: "+9%",
        },

        {
            label: "Appointments",
            value: "316",
            trend: "+12%",
        },

        {
            label: "Doctors",
            value: "84",
            trend: "On Duty",
        },

        {
            label: "Emergency",
            value: "27",
            trend: "Active",
        },

    ],

    chart: {

        title: "Patient Admissions",

        values: [
            42,
            58,
            51,
            67,
            74,
            81,
            69,
        ],

    },

    activities: [

        {
            title: "Discharge",
            description: "Patient released.",
            status: "success",
        },

        {
            title: "Emergency",
            description: "ICU admitted.",
            status: "warning",
        },

        {
            title: "Laboratory",
            description: "Reports ready.",
            status: "info",
        },

        {
            title: "Schedule",
            description: "OPD updated.",
            status: "success",
        },

    ],

    progress: [

        {
            label: "Appointments",
            value: 94,
        },

        {
            label: "Laboratory",
            value: 91,
        },

        {
            label: "Pharmacy",
            value: 96,
        },

        {
            label: "Billing",
            value: 88,
        },

    ],

    statuses: [

        {
            title: "Beds",
            subtitle: "Occupied",
            status: "84%",
            color: "green",
        },

        {
            title: "ICU",
            subtitle: "Capacity",
            status: "72%",
            color: "blue",
        },

        {
            title: "Pharmacy",
            subtitle: "Stock",
            status: "Healthy",
            color: "green",
        },

        {
            title: "Laboratory",
            subtitle: "Reports",
            status: "Pending",
            color: "yellow",
        },

    ],

    insights: [

        "Increase OPD slots.",

        "Review ICU capacity.",

        "Automate discharge.",

        "Reduce lab delays.",

    ],
};

export const educationPreview: DashboardPreview = {

    metrics: [

        {
            label: "Students",
            value: "2,486",
            trend: "+8%",
        },

        {
            label: "Attendance",
            value: "96.8%",
            trend: "+1.2%",
        },

        {
            label: "Faculty",
            value: "184",
            trend: "Present",
        },

        {
            label: "Fees",
            value: "91%",
            trend: "+6%",
        },

    ],

    chart: {

        title: "Admissions",

        values: [
            22,
            35,
            44,
            63,
            76,
            81,
            94,
        ],

    },

    activities: [

        {
            title: "Admissions",
            description: "24 approved.",
            status: "success",
        },

        {
            title: "Exams",
            description: "Schedule released.",
            status: "info",
        },

        {
            title: "Fees",
            description: "Reminder sent.",
            status: "warning",
        },

        {
            title: "Attendance",
            description: "Records synced.",
            status: "success",
        },

    ],

    progress: [

        {
            label: "Admissions",
            value: 93,
        },

        {
            label: "Attendance",
            value: 97,
        },

        {
            label: "Fee Collection",
            value: 91,
        },

        {
            label: "Examinations",
            value: 88,
        },

    ],

    statuses: [

        {
            title: "Students",
            subtitle: "Active",
            status: "Healthy",
            color: "green",
        },

        {
            title: "Faculty",
            subtitle: "Availability",
            status: "Normal",
            color: "blue",
        },

        {
            title: "Transport",
            subtitle: "Routes",
            status: "Running",
            color: "green",
        },

        {
            title: "Library",
            subtitle: "Requests",
            status: "Review",
            color: "yellow",
        },

    ],

    insights: [

        "Improve attendance.",

        "Automate admissions.",

        "Track fee dues.",

        "Monitor exam results.",

    ],

};

export const retailPreview: DashboardPreview = {

    metrics: [

        {
            label: "Sales",
            value: "$1.84M",
            trend: "+16%",
        },

        {
            label: "Orders",
            value: "4,286",
            trend: "+11%",
        },

        {
            label: "Customers",
            value: "12.4K",
            trend: "+8%",
        },

        {
            label: "Returns",
            value: "1.8%",
            trend: "-0.4%",
        },

    ],

    chart: {

        title: "Sales Trend",

        values: [
            42,
            56,
            61,
            73,
            79,
            88,
            95,
        ],

    },

    activities: [

        {
            title: "Order Shipped",
            description: "Express delivery.",
            status: "success",
        },

        {
            title: "Stock Alert",
            description: "Low inventory.",
            status: "warning",
        },

        {
            title: "Promotion",
            description: "Campaign launched.",
            status: "info",
        },

        {
            title: "Refund",
            description: "Processed today.",
            status: "success",
        },

    ],

    progress: [

        {
            label: "Sales Target",
            value: 92,
        },

        {
            label: "Order Fulfilment",
            value: 96,
        },

        {
            label: "Inventory Accuracy",
            value: 94,
        },

        {
            label: "Customer Satisfaction",
            value: 90,
        },

    ],

    statuses: [

        {
            title: "Inventory",
            subtitle: "Warehouses",
            status: "Healthy",
            color: "green",
        },

        {
            title: "Orders",
            subtitle: "Processing",
            status: "Normal",
            color: "blue",
        },

        {
            title: "Returns",
            subtitle: "Quality",
            status: "Review",
            color: "yellow",
        },

        {
            title: "Promotions",
            subtitle: "Campaigns",
            status: "Running",
            color: "green",
        },

    ],

    insights: [

        "Boost repeat sales.",

        "Replenish fast movers.",

        "Optimise promotions.",

        "Review return trends.",

    ],

};

export const logisticsPreview: DashboardPreview = {

    metrics: [

        {
            label: "Deliveries",
            value: "1,284",
            trend: "+9%",
        },

        {
            label: "Fleet",
            value: "142",
            trend: "Active",
        },

        {
            label: "Routes",
            value: "84",
            trend: "+3%",
        },

        {
            label: "On Time",
            value: "97%",
            trend: "+2%",
        },

    ],

    chart: {

        title: "Delivery Performance",

        values: [
            45,
            51,
            58,
            69,
            77,
            84,
            92,
        ],

    },

    activities: [

        {
            title: "Dispatch",
            description: "Fleet assigned.",
            status: "success",
        },

        {
            title: "Route",
            description: "Optimised today.",
            status: "info",
        },

        {
            title: "Delay",
            description: "Traffic alert.",
            status: "warning",
        },

        {
            title: "Warehouse",
            description: "Loading complete.",
            status: "success",
        },

    ],

    progress: [

        {
            label: "Fleet Utilisation",
            value: 91,
        },

        {
            label: "Delivery SLA",
            value: 97,
        },

        {
            label: "Route Efficiency",
            value: 88,
        },

        {
            label: "Warehouse Throughput",
            value: 93,
        },

    ],

    statuses: [

        {
            title: "Fleet",
            subtitle: "Vehicles",
            status: "Available",
            color: "green",
        },

        {
            title: "Routes",
            subtitle: "Schedules",
            status: "Running",
            color: "blue",
        },

        {
            title: "Warehouse",
            subtitle: "Loading",
            status: "Healthy",
            color: "green",
        },

        {
            title: "Traffic",
            subtitle: "Conditions",
            status: "Monitor",
            color: "yellow",
        },

    ],

    insights: [

        "Optimise delivery routes.",

        "Reduce idle vehicles.",

        "Review delay hotspots.",

        "Improve warehouse flow.",

    ],

};

export const genericPreview: DashboardPreview = {

    metrics: [

        {
            label: "Projects",
            value: "48",
            trend: "+7%",
        },

        {
            label: "Tasks",
            value: "864",
            trend: "+15%",
        },

        {
            label: "Users",
            value: "326",
            trend: "+5%",
        },

        {
            label: "Completion",
            value: "94%",
            trend: "+3%",
        },

    ],

    chart: {

        title: "Project Progress",

        values: [
            34,
            42,
            55,
            67,
            73,
            81,
            93,
        ],

    },

    activities: [

        {
            title: "Workflow",
            description: "Approved today.",
            status: "success",
        },

        {
            title: "Review",
            description: "Pending action.",
            status: "warning",
        },

        {
            title: "Meeting",
            description: "Scheduled today.",
            status: "info",
        },

        {
            title: "Release",
            description: "Version deployed.",
            status: "success",
        },

    ],

    progress: [

        {
            label: "Project Delivery",
            value: 94,
        },

        {
            label: "Quality Assurance",
            value: 91,
        },

        {
            label: "Automation",
            value: 87,
        },

        {
            label: "Documentation",
            value: 96,
        },

    ],

    statuses: [

        {
            title: "Projects",
            subtitle: "Portfolio",
            status: "Healthy",
            color: "green",
        },

        {
            title: "Workflow",
            subtitle: "Automation",
            status: "Running",
            color: "blue",
        },

        {
            title: "Support",
            subtitle: "Tickets",
            status: "Review",
            color: "yellow",
        },

        {
            title: "Releases",
            subtitle: "Deployments",
            status: "Stable",
            color: "green",
        },

    ],

    insights: [

        "Increase automation.",

        "Review overdue tasks.",

        "Track delivery KPIs.",

        "Improve documentation.",

    ],

};